const RETURN_KEY = 'ml_return_delete_account';

let memoryFlag = false;

/** After sign-in from Delete account, stay on that screen instead of opening the dashboard. */
export function markDeleteAccountReturn(): void {
  memoryFlag = true;
  if (typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.setItem(RETURN_KEY, '1');
  } catch {
    // Private mode / non-web.
  }
}

export function consumeDeleteAccountReturn(): boolean {
  let fromStorage = false;
  if (typeof sessionStorage !== 'undefined') {
    try {
      fromStorage = sessionStorage.getItem(RETURN_KEY) === '1';
      sessionStorage.removeItem(RETURN_KEY);
    } catch {
      fromStorage = false;
    }
  }
  const pending = memoryFlag || fromStorage;
  memoryFlag = false;
  return pending;
}
